
export default function CTA() {
  return (
    <section className="py-20 lg:py-28 bg-gradient-to-r from-teal-600 via-teal-700 to-blue-700 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')]"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Ready to Transform Your Hiring?
        </h2>
        <p className="text-xl lg:text-2xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
          Partner with us to access top talent and streamline your recruitment process. Let's build your dream team together.
        </p>
        
        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            className="inline-flex items-center px-8 py-4 bg-white text-teal-700 text-lg font-semibold rounded-lg hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-line mr-2"></i>
            Schedule Consultation
          </a>
          <a
            href="#services"
            className="inline-flex items-center px-8 py-4 bg-transparent border-2 border-white text-white text-lg font-semibold rounded-lg hover:bg-white hover:text-teal-700 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-briefcase-line mr-2"></i>
            View Open Positions
          </a>
        </div>
      </div>
    </section>
  );
}
